
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("fpKgX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bca7db035e003e4$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $c6sb7 = parcelRequire("c6sb7");

var $1Sitn = parcelRequire("1Sitn");
const $2bca7db035e003e4$var$PartnersList = ({ partners: partners = [] })=>/*#__PURE__*/ (0, $1dxTK.jsx)("div", {
        className: $1Sitn.sponsors,
        children: partners.map((sponsor)=>/*#__PURE__*/ (0, $1dxTK.jsx)((0, $c6sb7.default), {
                type: sponsor
            }, sponsor))
    });
var $2bca7db035e003e4$export$2e2bcd8739ae039 = $2bca7db035e003e4$var$PartnersList;

});
parcelRegister("c6sb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b2d4e2e0dfc6c81$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $kkRwB = parcelRequire("kkRwB");

var $f37rc = parcelRequire("f37rc");

var $kouMr = parcelRequire("kouMr");

var $b6YI6 = parcelRequire("b6YI6");

var $RVkXu = parcelRequire("RVkXu");

var $dq7Cu = parcelRequire("dq7Cu");

var $5gHjC = parcelRequire("5gHjC");

var $1bkVW = parcelRequire("1bkVW");

var $lhVvH = parcelRequire("lhVvH");

var $98dSF = parcelRequire("98dSF");

var $1lbF9 = parcelRequire("1lbF9");

var $4dq5X = parcelRequire("4dq5X");

var $4E3Rj = parcelRequire("4E3Rj");

var $2feky = parcelRequire("2feky");

var $23nCK = parcelRequire("23nCK");

var $fMrR8 = parcelRequire("fMrR8");

var $aiyJJ = parcelRequire("aiyJJ");

var $4MCsx = parcelRequire("4MCsx");

var $2kIpo = parcelRequire("2kIpo");

var $jekpD = parcelRequire("jekpD");

var $4igMz = parcelRequire("4igMz");

var $jmVJ2 = parcelRequire("jmVJ2");

var $4IYhV = parcelRequire("4IYhV");

var $goD7A = parcelRequire("goD7A");

var $26BSg = parcelRequire("26BSg");

var $7TxRF = parcelRequire("7TxRF");

var $iHz7j = parcelRequire("iHz7j");

var $gGGjy = parcelRequire("gGGjy");

var $4Nbnm = parcelRequire("4Nbnm");

var $gLXLR = parcelRequire("gLXLR");

var $745tm = parcelRequire("745tm");

var $aOb8A = parcelRequire("aOb8A");

var $5QVRZ = parcelRequire("5QVRZ");
const $8b2d4e2e0dfc6c81$var$partners = (lng)=>({
        THEBRICKFILMERSGUILD: {
            title: "The Brickfilmers Guild",
            link: "http://www.brickfilmersguild.com/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($b6YI6))),
                (0, (/*@__PURE__*/$parcel$interopDefault($RVkXu))),
                (0, (/*@__PURE__*/$parcel$interopDefault($kouMr)))
            ]
        },
        BRICKPIRATE: {
            title: "BrickPirate",
            link: "https://www.brickpirate.net/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($5gHjC))),
                (0, (/*@__PURE__*/$parcel$interopDefault($1bkVW))),
                (0, (/*@__PURE__*/$parcel$interopDefault($dq7Cu)))
            ]
        },
        BRICKSTUFF: {
            title: "BrickStuff",
            link: "https://www.brickstuff.com/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($4E3Rj))),
                (0, (/*@__PURE__*/$parcel$interopDefault($2feky))),
                (0, (/*@__PURE__*/$parcel$interopDefault($4dq5X)))
            ]
        },
        BRICKWARRIORS: {
            title: "BrickWarriors",
            link: "https://www.brickwarriors.com/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($fMrR8))),
                (0, (/*@__PURE__*/$parcel$interopDefault($aiyJJ))),
                (0, (/*@__PURE__*/$parcel$interopDefault($23nCK)))
            ]
        },
        EUROBRICKS: {
            title: "EuroBricks",
            link: "https://www.eurobricks.com/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($jmVJ2))),
                (0, (/*@__PURE__*/$parcel$interopDefault($4IYhV))),
                (0, (/*@__PURE__*/$parcel$interopDefault($4igMz)))
            ]
        },
        LAPETITEBRIQUE: {
            title: lng === "fr" ? "La Petite Brique" : "The Little Brick",
            link: "https://www.lapetitebrique.com/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($gGGjy))),
                (0, (/*@__PURE__*/$parcel$interopDefault($4Nbnm))),
                (0, (/*@__PURE__*/$parcel$interopDefault($iHz7j)))
            ]
        },
        LEGO: {
            title: "LEGO",
            link: "https://www.lego.com/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($26BSg))),
                (0, (/*@__PURE__*/$parcel$interopDefault($7TxRF))),
                (0, (/*@__PURE__*/$parcel$interopDefault($goD7A)))
            ]
        },
        BRICKOUEST: {
            title: "Brickouest",
            link: "https://brickouest.fr/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($98dSF))),
                (0, (/*@__PURE__*/$parcel$interopDefault($1lbF9))),
                (0, (/*@__PURE__*/$parcel$interopDefault($lhVvH)))
            ]
        },
        PUISSANCEBRICK: {
            title: "Puissance Brick",
            link: "https://www.puissancebrick.fr/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($745tm))),
                (0, (/*@__PURE__*/$parcel$interopDefault($aOb8A))),
                (0, (/*@__PURE__*/$parcel$interopDefault($gLXLR)))
            ]
        },
        CHTILUG: {
            title: "Ch'ti LUG",
            link: "https://www.chtilug.fr/",
            image: [
                (0, (/*@__PURE__*/$parcel$interopDefault($2kIpo))),
                (0, (/*@__PURE__*/$parcel$interopDefault($jekpD))),
                (0, (/*@__PURE__*/$parcel$interopDefault($4MCsx)))
            ]
        }
    });
const $8b2d4e2e0dfc6c81$var$PartnerLogo = ({ type: type, language: language = "en" })=>{
    const partner = $8b2d4e2e0dfc6c81$var$partners(language)?.[type];
    if (!partner) return null;
    return /*#__PURE__*/ (0, $1dxTK.jsx)((0, $f37rc.default), {
        title: partner.title,
        action: partner.link,
        children: /*#__PURE__*/ (0, $1dxTK.jsx)("img", {
            className: $5QVRZ.image,
            alt: partner.title,
            src: (0, $kkRwB.chooseBestImage)(partner.image),
            loading: "lazy"
        })
    });
};
var $8b2d4e2e0dfc6c81$export$2e2bcd8739ae039 = $8b2d4e2e0dfc6c81$var$PartnerLogo;

});
parcelRegister("kouMr", function(module, exports) {
module.exports = new URL("bfg.5fa19d35.avif", import.meta.url).toString();

});

parcelRegister("b6YI6", function(module, exports) {
module.exports = new URL("bfg.9943b7ba.png", import.meta.url).toString();

});

parcelRegister("RVkXu", function(module, exports) {
module.exports = new URL("bfg.9bed7f8e.webp", import.meta.url).toString();

});

parcelRegister("dq7Cu", function(module, exports) {
module.exports = new URL("bp.17919c8e.avif", import.meta.url).toString();

});

parcelRegister("5gHjC", function(module, exports) {
module.exports = new URL("bp.422210f2.png", import.meta.url).toString();

});

parcelRegister("1bkVW", function(module, exports) {
module.exports = new URL("bp.451c5e76.webp", import.meta.url).toString();

});

parcelRegister("lhVvH", function(module, exports) {
module.exports = new URL("brickouest.53fe3369.avif", import.meta.url).toString();

});

parcelRegister("98dSF", function(module, exports) {
module.exports = new URL("brickouest.ff94a4a9.png", import.meta.url).toString();

});

parcelRegister("1lbF9", function(module, exports) {
module.exports = new URL("brickouest.73c248cd.webp", import.meta.url).toString();

});

parcelRegister("4dq5X", function(module, exports) {
module.exports = new URL("brickstuff.a675589e.avif", import.meta.url).toString();

});

parcelRegister("4E3Rj", function(module, exports) {
module.exports = new URL("brickstuff.a0c14a49.png", import.meta.url).toString();

});

parcelRegister("2feky", function(module, exports) {
module.exports = new URL("brickstuff.2953384a.webp", import.meta.url).toString();

});

parcelRegister("23nCK", function(module, exports) {
module.exports = new URL("brickwarriors.6bb2f002.avif", import.meta.url).toString();

});

parcelRegister("fMrR8", function(module, exports) {
module.exports = new URL("brickwarriors.b43feab8.png", import.meta.url).toString();

});

parcelRegister("aiyJJ", function(module, exports) {
module.exports = new URL("brickwarriors.4094d249.webp", import.meta.url).toString();

});

parcelRegister("4MCsx", function(module, exports) {
module.exports = new URL("chtilug.3f33fb35.avif", import.meta.url).toString();

});

parcelRegister("2kIpo", function(module, exports) {
module.exports = new URL("chtilug.adb3777e.png", import.meta.url).toString();

});

parcelRegister("jekpD", function(module, exports) {
module.exports = new URL("chtilug.6cb02270.webp", import.meta.url).toString();

});

parcelRegister("4igMz", function(module, exports) {
module.exports = new URL("eurobricks.ecfe9786.avif", import.meta.url).toString();

});

parcelRegister("jmVJ2", function(module, exports) {
module.exports = new URL("eurobricks.7a7caab3.png", import.meta.url).toString();

});

parcelRegister("4IYhV", function(module, exports) {
module.exports = new URL("eurobricks.39d2984d.webp", import.meta.url).toString();

});

parcelRegister("goD7A", function(module, exports) {
module.exports = new URL("lego.58307dda.avif", import.meta.url).toString();

});

parcelRegister("26BSg", function(module, exports) {
module.exports = new URL("lego.f7e59d26.png", import.meta.url).toString();

});

parcelRegister("7TxRF", function(module, exports) {
module.exports = new URL("lego.aa2fe116.webp", import.meta.url).toString();

});

parcelRegister("iHz7j", function(module, exports) {
module.exports = new URL("lpb.a0612b0e.avif", import.meta.url).toString();

});

parcelRegister("gGGjy", function(module, exports) {
module.exports = new URL("lpb.a7a899ad.png", import.meta.url).toString();

});

parcelRegister("4Nbnm", function(module, exports) {
module.exports = new URL("lpb.79c7d145.webp", import.meta.url).toString();

});

parcelRegister("gLXLR", function(module, exports) {
module.exports = new URL("puissancebrick.3aa77eec.avif", import.meta.url).toString();

});

parcelRegister("745tm", function(module, exports) {
module.exports = new URL("puissancebrick.34b746ad.png", import.meta.url).toString();

});

parcelRegister("aOb8A", function(module, exports) {
module.exports = new URL("puissancebrick.c588632c.webp", import.meta.url).toString();

});

parcelRegister("5QVRZ", function(module, exports) {

$parcel$export(module.exports, "image", function () { return $442eb2d254efb22c$export$5c452ff88e35e47d; }, function (v) { return $442eb2d254efb22c$export$5c452ff88e35e47d = v; });
var $442eb2d254efb22c$export$5c452ff88e35e47d;
$442eb2d254efb22c$export$5c452ff88e35e47d = `lAx5oq_image`;

});


parcelRegister("1Sitn", function(module, exports) {

$parcel$export(module.exports, "sponsors", function () { return $15d929e61d35ceae$export$14e304d9e12f4092; }, function (v) { return $15d929e61d35ceae$export$14e304d9e12f4092 = v; });
var $15d929e61d35ceae$export$14e304d9e12f4092;
$15d929e61d35ceae$export$14e304d9e12f4092 = `bQhm5a_sponsors`;

});



//# sourceMappingURL=Homepage.ca8c8bde.js.map
